import React, { useEffect } from 'react';
// import "bootstrap/dist/css/bootstrap.css";
// import "react-bootstrap-carousel/dist/react-bootstrap-carousel.css";
// import moment from 'moment';
import './../../webcss/default.css';
import './../../webcss/styles.css';
import Header from './header';
import Footer from './footer';

function PaymentPolicy() {

    useEffect(() => {
        // setReportMode(Apps);
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <div>
                <Header />
                <div>
                    <div className="notice-section notice-section-sm border-top red">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-10 col-sm-10 col-12">
                                    <div className="mt-5">
                                        <h6 className="fontwhite">Become a SR PAY Private Limited Franchise &amp; Grow your income 30% to 50% per month
                                        </h6>
                                    </div>
                                </div>
                                <div className="col-md-2 col-sm-2 col-12">
                                    <div className="right-holder-md">
                                        <a href="/joinus" className="primary-button button-lg mt-15-xs bluebtn">Join Now</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="page-title-section">
                        <div className="container">
                            <h1>Payment <span className="white"> &amp; Settlement Policy</span></h1>
                        </div>
                    </div>
                    <div className>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 col-sm-12 col-12">
                                    <div className="pl-30-md mt-40">
                                        <div className="text-content-big mt-20">

                                            <p><strong>BBPS PAYMENT &amp; SETTLEMENT POLICY</strong></p>

                                            <h5><b>1. Purpose</b></h5>
                                            <p>This Payment &amp; Settlement Policy ("Policy") governs the collection, processing, settlement, reconciliation, refunds, disputes, and related obligations applicable to merchants, distributors, agents, and business partners utilizing Bharat Bill Payment System (BBPS) services provided by SR PAY Private Limited ("Company").</p>
                                            <p>This Policy shall be read in conjunction with applicable guidelines issued by the National Payments Corporation of India (NPCI), Reserve Bank of India (RBI), sponsoring banks, payment gateway partners, and other applicable laws and regulations.</p>
                                            <br />

                                            <h5><b>2. Scope</b></h5>
                                            <p>This Policy applies to all BBPS services facilitated by the Company, including but not limited to:</p>
                                            <ul className="details">
                                                <li>Electricity Bill Payments</li>
                                                <li>Water Bill Payments</li>
                                                <li>Gas Bill Payments</li>
                                                <li>Mobile Postpaid Bills</li>
                                                <li>Broadband &amp; Landline Bills</li>
                                                <li>DTH Bill Payments</li>
                                                <li>FASTag Recharge</li>
                                                <li>Insurance Premium Payments</li>
                                                <li>Loan Repayments</li>
                                                <li>Municipal Taxes</li>
                                                <li>Any other BBPS category introduced from time to time</li>
                                            </ul>
                                            <br />

                                            <h5><b>3. Merchant Payment Collection Mechanism</b></h5>
                                            <p><b>3.1 Payment Gateway Based Collection</b></p>
                                            <p>The Company operates a payment gateway-based collection model for BBPS services. Merchants shall make payments through approved electronic payment modes including UPI, Net Banking, Debit Card, Credit Card, Virtual Account, or any other mode approved by the Company.</p>

                                            <p><b>3.2 Transaction Processing</b></p>
                                            <p>BBPS transactions shall be processed based on successful receipt and settlement of funds through the Company's designated payment gateway and banking partners.</p>

                                            <p><b>3.3 Settlement Confirmation</b></p>
                                            <p>A payment shall be deemed received only after successful confirmation and settlement by the payment gateway, acquiring bank, payment aggregator, sponsoring bank, or other authorized payment partner.</p>

                                            <p><b>3.4 Failed, Reversed or Disputed Payments</b></p>
                                            <p>Where a payment is reversed, disputed, charged back, rejected, or not settled by the payment gateway, bank, or payment partner, the Company reserves the right to suspend services and recover any resulting loss.</p>

                                            <p><b>3.5 Compliance Requirements</b></p>
                                            <p>All payment transactions shall be subject to applicable RBI, NPCI, BBPS, banking, payment gateway, anti-money laundering, and regulatory guidelines.</p>

                                            <p><b>3.6 No Cash Collection</b></p>
                                            <p>The Company shall not accept direct cash deposits from merchants for BBPS transaction processing. All payments must be routed through approved banking channels and electronic payment systems.</p>
                                            <br />

                                            <h5><b>4. Settlement of Transactions</b></h5>
                                            <p><b>4.1 Successful Transactions</b></p>
                                            <p>A transaction shall be considered successful only upon confirmation from the concerned biller, BBPS network, NPCI, and settlement partners.</p>

                                            <p><b>4.2 Settlement Cycle</b></p>
                                            <p>Merchant settlements, commissions, incentives, and other eligible earnings shall be processed as per the settlement cycle communicated by the Company from time to time.</p>

                                            <p><b>4.3 Settlement Mode</b></p>
                                            <p>Settlements shall be made through electronic banking channels including IMPS, NEFT, RTGS, UPI, or any other approved method.</p>

                                            <p><b>4.4 Settlement Delays</b></p>
                                            <p>The Company shall not be responsible for settlement delays caused by:</p>
                                            <ul className="details">
                                                <li>NPCI systems</li>
                                                <li>Biller systems</li>
                                                <li>Payment gateway systems</li>
                                                <li>Banking network issues</li>
                                                <li>Regulatory restrictions</li>
                                                <li>Technical failures</li>
                                                <li>Force majeure events</li>
                                            </ul>
                                            <br />

                                            <h5><b>5. Commission and Charges</b></h5>
                                            <p><b>5.1 Commission Structure</b></p>
                                            <p>Merchants shall be entitled to commissions and incentives as notified by the Company from time to time.</p>

                                            <p><b>5.2 Modification Rights</b></p>
                                            <p>The Company reserves the right to revise commissions, incentives, service charges, settlement structures, and commercial terms at its sole discretion.</p>

                                            <p><b>5.3 Taxes</b></p>
                                            <p>Applicable GST, TDS, statutory deductions, or government levies shall be deducted wherever applicable.</p>
                                            <br />

                                            <h5><b>6. Failed Transactions and Refunds</b></h5>
                                            <p><b>6.1 Failed Transactions</b></p>
                                            <p>Transactions that fail due to technical, banking, biller, NPCI, or payment gateway reasons shall be reconciled and processed as per applicable guidelines.</p>

                                            <p><b>6.2 Refund Timeline</b></p>
                                            <p>Refunds or reversals shall normally be processed within T+1 to T+7 working days or such timeline as prescribed by NPCI, billers, banks, or payment partners.</p>

                                            <p><b>6.3 Reconciliation Requirement</b></p>
                                            <p>Refund processing shall be subject to successful reconciliation with the biller, bank, NPCI, payment gateway, or sponsoring partner.</p>

                                            <p><b>6.4 Non-Refundable Charges</b></p>
                                            <p>Convenience fees, gateway charges, taxes, and service charges may be non-refundable wherever permitted by applicable laws.</p>
                                            <br />

                                            <h5><b>7. Reconciliation</b></h5>
                                            <p><b>7.1 Daily Reconciliation</b></p>
                                            <p>The Company shall perform reconciliation of transactions based on records received from NPCI, billers, payment gateways, and banking partners.</p>

                                            <p><b>7.2 Dispute Reporting</b></p>
                                            <p>Merchants must report settlement discrepancies within 7 days from the transaction date.</p>

                                            <p><b>7.3 Final Acceptance</b></p>
                                            <p>Transactions not disputed within the prescribed period shall be deemed accepted and final.</p>
                                            <br />

                                            <h5><b>8. Merchant KYC and Due Diligence</b></h5>
                                            <p><b>8.1 KYC Requirement</b></p>
                                            <p>Provision of BBPS services is subject to successful completion and verification of KYC documentation.</p>

                                            <p><b>8.2 Additional Verification</b></p>
                                            <p>The Company may request additional information, documentation, declarations, or compliance records at any time.</p>

                                            <p><b>8.3 Suspension for Non-Compliance</b></p>
                                            <p>Failure to provide required documents may result in suspension or termination of services.</p>
                                            <br />

                                            <h5><b>9. Chargeback and Dispute Management</b></h5>
                                            <p><b>9.1 Chargeback Rights</b></p>
                                            <p>The Company reserves the right to investigate and process chargebacks, disputes, reversals, and customer complaints.</p>

                                            <p><b>9.2 Merchant Cooperation</b></p>
                                            <p>Merchants shall provide all requested records and supporting documents within the timeframe prescribed by the Company.</p>

                                            <p><b>9.3 Recovery</b></p>
                                            <p>Any chargeback, refund, reversal, or dispute liability may be adjusted against future settlements or recovered directly from the merchant.</p>
                                            <br />

                                            <h5><b>10. Suspension of Settlement</b></h5>
                                            <p>The Company may suspend, delay, or withhold settlements where:</p>
                                            <ul className="details">
                                                <li>Fraud is suspected.</li>
                                                <li>KYC verification is incomplete.</li>
                                                <li>Regulatory investigation is pending.</li>
                                                <li>Excessive disputes or complaints are observed.</li>
                                                <li>Merchant activities pose financial or compliance risks.</li>
                                                <li>Directions are received from NPCI, RBI, banks, payment gateways, or government authorities.</li>
                                            </ul>
                                            <br />

                                            <h5><b>11. Risk Management, Merchant Obligations and Recovery Rights</b></h5>
                                            <p><b>11.1 Settlement Hold and Reserve Rights</b></p>
                                            <p>The Company reserves the right to withhold, delay, suspend, retain, or create reserves against settlements where risk exposure, disputes, refunds, fraud, investigations, or compliance concerns exist.</p>

                                            <p><b>11.2 Prohibited Transactions</b></p>
                                            <p>Merchants shall not engage in:</p>
                                            <ul className="details">
                                                <li>Money laundering activities.</li>
                                                <li>Fake bill payments.</li>
                                                <li>Self-generated transactions.</li>
                                                <li>Transactions using unauthorized identities.</li>
                                                <li>Regulatory violations.</li>
                                                <li>Activities prohibited under applicable laws.</li>
                                            </ul>

                                            <p><b>11.3 Negative Balance Recovery</b></p>
                                            <p>Any negative balance arising due to refunds, disputes, chargebacks, reversals, fraud, operational errors, penalties, or regulatory action shall be immediately payable by the merchant.</p>
                                            <p>The Company may recover such amounts from:</p>
                                            <ul className="details">
                                                <li>Future settlements.</li>
                                                <li>Commission payouts.</li>
                                                <li>Security deposits.</li>
                                                <li>Legal recovery proceedings.</li>
                                            </ul>

                                            <p><b>11.4 Indemnity</b></p>
                                            <p>The merchant shall indemnify and hold harmless the Company, its directors, employees, officers, banking partners, payment gateway partners, and service providers against any loss, claim, penalty, damage, liability, legal proceeding, regulatory action, or expense arising from:</p>
                                            <ul className="details">
                                                <li>Merchant misconduct.</li>
                                                <li>Fraudulent transactions.</li>
                                                <li>Regulatory violations.</li>
                                                <li>Customer disputes.</li>
                                                <li>Breach of this Policy.</li>
                                            </ul>

                                            <p><b>11.5 Suspension and Termination</b></p>
                                            <p>The Company may immediately suspend or terminate services without prior notice in case of:</p>
                                            <ul className="details">
                                                <li>Fraudulent activity.</li>
                                                <li>Compliance violations.</li>
                                                <li>KYC deficiencies.</li>
                                                <li>Regulatory directives.</li>
                                                <li>Misuse of BBPS services.</li>
                                                <li>Material breach of this Policy.</li>
                                            </ul>
                                            <p>The Company may continue to hold settlements until reconciliation, dispute resolution, and recovery proceedings are completed.</p>
                                            <br />

                                            <h5><b>12. Audit Rights</b></h5>
                                            <p>The Company reserves the right to conduct operational, financial, compliance, risk, and transaction audits of merchants at any time.</p>
                                            <p>Merchants shall provide access to records, invoices, transaction logs, and supporting documents as requested.</p>
                                            <br />

                                            <h5><b>13. Record Retention</b></h5>
                                            <p>Merchants shall maintain transaction records, invoices, customer acknowledgements, and supporting documents for a minimum period of eight (8) years or such longer period as prescribed under applicable law.</p>
                                            <br />

                                            <h5><b>14. Limitation of Liability</b></h5>
                                            <p>The Company's liability in relation to any transaction, dispute, or claim shall be limited to the actual transaction amount received by the Company.</p>
                                            <p>Under no circumstances shall the Company be liable for indirect, consequential, incidental, special, punitive, or business losses.</p>
                                            <br />

                                            <h5><b>15. Force Majeure</b></h5>
                                            <p>The Company shall not be liable for any delay, interruption, failure, or inability to perform its obligations due to events beyond its reasonable control, including:</p>
                                            <ul className="details">
                                                <li>Natural disasters</li>
                                                <li>Floods</li>
                                                <li>Earthquakes</li>
                                                <li>Cyber attacks</li>
                                                <li>System failures</li>
                                                <li>Government actions</li>
                                                <li>Regulatory restrictions</li>
                                                <li>Banking disruptions</li>
                                                <li>NPCI or biller outages</li>
                                                <li>War, riots, strikes, or civil disturbances</li>
                                            </ul>
                                            <br />

                                            <h5><b>16. Amendments</b></h5>
                                            <p>The Company reserves the right to modify, amend, replace, or update this Policy at any time. Such amendments shall become effective upon publication or communication by the Company.</p>
                                            <br />

                                            <h5><b>17. Governing Law and Jurisdiction</b></h5>
                                            <p>This Policy shall be governed by and construed in accordance with the laws of India.</p>
                                            <p>Any dispute arising out of or relating to this Policy shall be subject to the exclusive jurisdiction of the competent courts at Jaipur, Rajasthan.</p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default PaymentPolicy;